import CellDocLibraryLinkDownload from './cells/CellDocLibraryLinkDownload';
import CellDocLibraryDocumentsNames from './cells/CellDocLibraryDocumentsNames';
import CellDocLibraryDocumentsCreatedDates from './cells/CellDocLibraryDocumentsCreatedDates';

export const getColumns = (t: (key: string) => string) => [
    {
        key: 'documentMetadataName',
        title: t('advisoryDashboard.documents.type'),
    },
    {
        key: 'productName',
        title: t('advisoryDashboard.documents.product'),
    },
    {
        key: 'version',
        title: t('advisoryDashboard.documents.version'),
    },
    {
        key: 'documentsCreatedDates',
        title: t('advisoryDashboard.documents.uploadDate'),
        render: CellDocLibraryDocumentsCreatedDates,
    },
    {
        key: 'documentsFilesNames',
        title: t('advisoryDashboard.documents.pdfName'),
        render: CellDocLibraryDocumentsNames,
    },
    {
        key: 'linkDownload',
        title: `${t('research.downloadDocument')}/${t('clientDashboard.delete')}`,
        render: CellDocLibraryLinkDownload,
        width: 250,
    },
];
